// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Фон футера на всю ширину, контент в page-container */
.footer {
  width: 100%;
  background: #4e3f3a;
  margin-top: auto;
  flex-shrink: 0;
}

.footer__inner {
  padding-top: 24px;
  padding-bottom: 24px;
}

/* 1. Логотип по центру - 140×77 по макету */
.footer__logo-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.footer__logo {
  width: 140px;
  height: 77px;
  object-fit: contain;
  display: block;
}

/* 2. Навигация по центру - Roboto 20px, underline, #FFFFFF */
.footer__nav {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 48px;
  margin-bottom: 20px;
}

.footer__link {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 23px;
  text-decoration-line: underline;
  color: #ffffff;
}

.footer__link:hover {
  color: #ffffff;
  opacity: 0.9;
}

/* Перегородка между вторым и третьим слоем */
.footer__divider {
  border: none;
  border-top: 1px solid #ffffff;
  margin: 0 0 20px 0;
}

/* 3. Третий слой: три колонки */
.footer__bottom {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
}

.footer__legal,
.footer__contacts {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #ffffff;
  margin: 0;
  max-width: 500px;
}

.footer__legal p,
.footer__contacts p {
  margin: 0 0 4px 0;
}

.footer__legal p:last-child,
.footer__contacts p:last-child {
  margin-bottom: 0;
}

.footer__contacts {
  text-align: right;
}

/* Иконки соцсетей по центру - 62×62 */
.footer__social {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  flex-shrink: 0;
}

.footer__social-link {
  display: block;
  width: 62px;
  height: 62px;
  line-height: 0;
}

.footer__social-link:hover {
  opacity: 0.9;
}

.footer__social-link img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

/* Адаптив */
@media (max-width: 900px) {
  .footer__bottom {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .footer__contacts {
    text-align: center;
  }

  .footer__legal {
    text-align: center;
  }
}

@media (max-width: 600px) {
  .footer__nav {
    flex-direction: column;
    gap: 12px;
  }

  .footer__logo {
    width: 113px;
    height: 62px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA,uDAAuD;AACvD;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA,6CAA6C;AAC7C;EACE,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;AACF","sourcesContent":["/* Фон футера на всю ширину, контент в page-container */\n.footer {\n  width: 100%;\n  background: #4e3f3a;\n  margin-top: auto;\n  flex-shrink: 0;\n}\n\n.footer__inner {\n  padding-top: 24px;\n  padding-bottom: 24px;\n}\n\n/* 1. Логотип по центру - 140×77 по макету */\n.footer__logo-wrap {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 16px;\n}\n\n.footer__logo {\n  width: 140px;\n  height: 77px;\n  object-fit: contain;\n  display: block;\n}\n\n/* 2. Навигация по центру - Roboto 20px, underline, #FFFFFF */\n.footer__nav {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 48px;\n  margin-bottom: 20px;\n}\n\n.footer__link {\n  font-family: 'Roboto', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 23px;\n  text-decoration-line: underline;\n  color: #ffffff;\n}\n\n.footer__link:hover {\n  color: #ffffff;\n  opacity: 0.9;\n}\n\n/* Перегородка между вторым и третьим слоем */\n.footer__divider {\n  border: none;\n  border-top: 1px solid #ffffff;\n  margin: 0 0 20px 0;\n}\n\n/* 3. Третий слой: три колонки */\n.footer__bottom {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 24px;\n  flex-wrap: wrap;\n}\n\n.footer__legal,\n.footer__contacts {\n  font-family: 'Roboto', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 19px;\n  color: #ffffff;\n  margin: 0;\n  max-width: 500px;\n}\n\n.footer__legal p,\n.footer__contacts p {\n  margin: 0 0 4px 0;\n}\n\n.footer__legal p:last-child,\n.footer__contacts p:last-child {\n  margin-bottom: 0;\n}\n\n.footer__contacts {\n  text-align: right;\n}\n\n/* Иконки соцсетей по центру - 62×62 */\n.footer__social {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  flex-shrink: 0;\n}\n\n.footer__social-link {\n  display: block;\n  width: 62px;\n  height: 62px;\n  line-height: 0;\n}\n\n.footer__social-link:hover {\n  opacity: 0.9;\n}\n\n.footer__social-link img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n}\n\n/* Адаптив */\n@media (max-width: 900px) {\n  .footer__bottom {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n  }\n\n  .footer__contacts {\n    text-align: center;\n  }\n\n  .footer__legal {\n    text-align: center;\n  }\n}\n\n@media (max-width: 600px) {\n  .footer__nav {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .footer__logo {\n    width: 113px;\n    height: 62px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
